import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import "./TableChart.css";
import { countries } from "../../utils/constant";
import { formatNumberCommaSeparated, truncateNumber } from "../../utils/common";

// Sample Data Array
const data = [
  {
    name: "India",
    co2: "0",
    share: "0%",
    flag: "https://upload.wikimedia.org/wikipedia/commons/2/2c/India-flag-a4.jpg",
  },
  {
    name: "China",
    co2: "0",
    share: "0%",
    flag: "https://dm0qx8t0i9gc9.cloudfront.net/thumbnails/video/GTYSdDW/chinese-flag_bygsrmyls_thumbnail-1080_01.png",
  },
  {
    name: "United States",
    co2: "0",
    share: "0%",
    flag: "https://th.bing.com/th/id/OIP.qIVO5VLgIP2clXu2hCJ08QHaE1?w=267&h=180&c=7&r=0&o=5&dpr=1.5&pid=1.7",
  },
  {
    name: "Russia",
    co2: "0",
    share: "0%",
    flag: "https://th.bing.com/th?id=OIP.uW9Hi1USsULyX2e4Y7iy-gHaE7&w=306&h=204&c=8&rs=1&qlt=90&o=6&dpr=1.5&pid=3.1&rm=2",
  },
  {
    name: "Brazil",
    co2: "1,23,45,678",
    share: "14.50%",
    flag: "https://upload.wikimedia.org/wikipedia/commons/0/05/Flag_of_Brazil.svg",
  },
  {
    name: "Germany",
    co2: "98,76,543",
    share: "11.87%",
    flag: "https://upload.wikimedia.org/wikipedia/en/b/ba/Flag_of_Germany.svg",
  },
  {
    name: "Japan",
    co2: "87,65,432",
    share: "10.56%",
    flag: "https://upload.wikimedia.org/wikipedia/en/9/9e/Flag_of_Japan.svg",
  },
  {
    name: "Australia",
    co2: "75,43,210",
    share: "9.08%",
    flag: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Australia.svg",
  },
  {
    name: "Canada",
    co2: "65,43,210",
    share: "7.87%",
    flag: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Flag_of_Canada_%28Pantone%29.svg",
  },
  {
    name: "UK",
    co2: "54,32,109",
    share: "6.78%",
    flag: "https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg",
  },
];

const TableChartAmount = ({ tableData }) => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCountries = 5;

  const handleUpClick = () => {
    if (startIndex > 0) {
      setStartIndex((prevIndex) => prevIndex - 1);
    }
  };

  //   const handleDownClick = () => {
  //     if (startIndex < data.length - visibleCountries) {
  //       setStartIndex((prevIndex) => prevIndex + 1);
  //     }
  //   };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ padding: "8px" }}>
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  Country
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                >
                  <i
                    className="bi bi-caret-up-fill"
                    onClick={handleUpClick}
                    style={{
                      lineHeight: "1",
                      margin: "0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                  <i
                    className="bi bi-caret-down-fill"
                    // onClick={handleDownClick}
                    style={{
                      lineHeight: "1",
                      margin: "-4px 0 0 0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                </span>
              </TableCell>
              <TableCell style={{ padding: "8px" }}>
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  Amount Spent (USD)
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                >
                  <i
                    className="bi bi-caret-up-fill"
                    onClick={handleUpClick}
                    style={{
                      lineHeight: "1",
                      margin: "0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                  <i
                    className="bi bi-caret-down-fill"
                    // onClick={handleDownClick}
                    style={{
                      lineHeight: "1",
                      margin: "-4px 0 0 0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                </span>
              </TableCell>
              <TableCell style={{ padding: "8px" }}>
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  Share of World
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    flexDirection: "column",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                >
                  <i
                    className="bi bi-caret-up-fill"
                    onClick={handleUpClick}
                    style={{
                      lineHeight: "1",
                      margin: "0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                  <i
                    className="bi bi-caret-down-fill"
                    // onClick={handleDownClick}
                    style={{
                      lineHeight: "1",
                      margin: "-4px 0 0 0",
                      padding: "0",
                      fontSize: "12px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                  ></i>
                </span>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData && tableData?.length > 0 ? (
              tableData
                .slice(startIndex, startIndex + visibleCountries)
                .map((country, index) => {
                  const countryData = countries.find(
                    (c) => c.label === country.country
                  );
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <img
                            src={
                              countryData
                                ? `https://flagcdn.com/w320/${countryData.code.toLowerCase()}.png`
                                : country.flag || ""
                            }
                            alt={`${country.country} Flag`}
                            className="flag-icon"
                            style={{
                              width: "24px",
                              height: "16px",
                              objectFit: "contain",
                            }}
                          />
                          <span>{country.country}</span>
                        </div>
                      </TableCell>

                      <TableCell>
                        {formatNumberCommaSeparated(
                          truncateNumber(country?.emission ?? 0, 3)
                        ) ?? 0}
                      </TableCell>
                      <TableCell>
                        {country.percentage
                          ? country.percentage.toString().includes(".")
                            ? country.percentage.toString().split(".")[0] +
                              "." +
                              country.percentage
                                .toString()
                                .split(".")[1]
                                .slice(0, 2)
                            : country.percentage
                          : 0}{" "}
                        %
                      </TableCell>
                    </TableRow>
                  );
                })
            ) : (
              <TableRow sx={{ width: "100%" }}>
                <TableCell
                  colSpan={3}
                  sx={{
                    textAlign: "center",
                    color: "#d3d3d3",
                    fontWeight: "bold",
                    m: "8%",
                    fontSize: "20px",
                    fontFamily:"inter"
                  }}
                >
                 No Data Found
                </TableCell>
                {/* <NoDataFound /> */}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TableChartAmount;
